import React, { useState } from "react";
import "./Home.css";
import homePic from "../../Images/Content/heroPic.png";
import individual from "../../Images/Icons/1.png";
import family from "../../Images/Icons/2.png";
import life from "../../Images/Icons/3.png";

import WhyMeda from "../../Components/WhyMeda/WhyMeda";
import Testimonials from "../../Components/Testimonials/Testimonials";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLead } from "../../Context/LeadContext";

const ZIP_RE = /^\d{5}(?:-\d{4})?$/;

function formatZip(input) {
  // keep digits only, allow 9 max; insert hyphen after 5 if >5
  const digits = (input || "").replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

function Home() {
  const navigate = useNavigate();
  const { lead, setLead } = useLead();
  const [zip, setZip] = useState(lead.zip || "");
  const [touched, setTouched] = useState(false);

  const isValid = ZIP_RE.test(zip);
  const showError = touched && !isValid;

  function onZipChange(e) {
    setZip(formatZip(e.target.value));
  }

  function onZipBlur() {
    setTouched(true);
  }

  function onZipSubmit(e) {
    e.preventDefault();
    setTouched(true);
    if (!ZIP_RE.test(zip)) return;
    setLead((prev) => ({ ...prev, zip }));
    navigate("/quote", { state: { scrollToForm: true } });
  }

  return (
    <div className="home-container">
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              Find Affordable Individual and Family Health Insurance Plans
            </h1>
            <p>Plans can start as low as $9 per week!</p>
            <div className="heroZip">
              {/* ZIP form lives here */}
              <form onSubmit={onZipSubmit} className="zip-form" noValidate>
                <input
                  id="zip"
                  name="zip"
                  inputMode="numeric"
                  autoComplete="postal-code"
                  value={zip}
                  onChange={onZipChange}
                  onBlur={onZipBlur}
                  placeholder="ZIP code"
                  className={`zip-input ${showError ? "input-error" : ""}`}
                  aria-invalid={showError ? "true" : "false"}
                  aria-describedby="zip-help zip-error"
                />
                <button
                  type="submit"
                  className="zip-submit"
                  disabled={!isValid}
                >
                  Get Quote
                </button>

                {showError && (
                  <div id="zip-error" role="alert" className="zip-error-text">
                    Please enter a valid US ZIP code.
                  </div>
                )}
              </form>
            </div>
          </div>
          <div className="hero-image">
            <img src={homePic}></img>
          </div>
        </div>
      </section>

      <div className="hero-options-wrapper">
        <div className="hero-options">
          <div className="hero-individual" id="hero-options-cards">
            <img className="hero-icons" src={individual}></img>
            <p>Individual Plans</p>
          </div>
          <div className="hero-family" id="hero-options-cards">
            <img className="hero-icons" src={family}></img>
            <p>Family Coverage</p>
          </div>
          <div className="hero-life" id="hero-options-cards">
            <img className="hero-icons" src={life}></img>
            <p>Life Coverage</p>
          </div>
        </div>
      </div>
      <div className="home-content-wrapper">
        <section className="why-meda">
          <WhyMeda></WhyMeda>
        </section>

        {/* Services Section */}
        <section className="services">
          <h2>Our Services</h2>
          <div className="service-cards">
            <div className="service-top">
              <div className="card">
                <h4>Individual Health Plans</h4>
                <p>Affordable coverage options tailored to your lifestyle.</p>
              </div>
              <div className="card">
                <h4>Medicare Supplement</h4>
                <p>
                  Helping you fill the gaps in traditional Medicare coverage.
                </p>
              </div>
              <div className="card">
                <h4>Dental Insurance</h4>
                <p>Plans that help you maintain a healthy smile.</p>
              </div>
              <div className="card">
                <h4>Small Business Plans</h4>
                <p>
                  Coverage packages for your employees that won’t break the
                  bank.
                </p>
              </div>
            </div>
            <div className="service-bottom">
              <div className="card">
                <h4>Life Insurance</h4>
                <p>Affordable coverage options tailored to your lifestyle.</p>
              </div>
              <div className="card">
                <h4>Annuities</h4>
                <p>
                  Helping you fill the gaps in traditional Medicare coverage.
                </p>
              </div>
              <div className="card">
                <h4>Vision Insurance</h4>
                <p>Plans that help you maintain a healthy smile.</p>
              </div>
              <div className="card">
                <h4>Supplemental Coverage</h4>
                <p>
                  Coverage packages for your employees that won’t break the
                  bank.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Testimonials */}
      <section className="testimonials">
        <Testimonials></Testimonials>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <h2>Ready to get started?</h2>
        <Link to="/quote" className="cta-button2">
          Get a Free Quote
        </Link>
      </section>
    </div>
  );
}

export default Home;
